import { IString } from '../../../model';

const LOCAL_GAME_FILTER_KEY = 'game-filter-record';

export const setLocalGameFilter = (gameId: string, envId: number) => {
  const obj = getLocalGameFilter();
  Object.assign(obj, {
    [gameId]: envId,
  });
  localStorage.setItem(LOCAL_GAME_FILTER_KEY, JSON.stringify(obj));
};

export const getLocalGameFilter = (): IString<string> => {
  try {
    return JSON.parse(localStorage.getItem(LOCAL_GAME_FILTER_KEY) || '{}');
  } catch (err) {
    return {};
  }
};

export const getLocalGameFilterByGame = (gameID: string) => {
  const config = getLocalGameFilter();
  return Number(config[gameID]) || null;
};
